/*---------------------------------------------------------------------------------
                                ETIQUETAS Y MENSAJES
 Contiene las etiquetas y mensajes generales del sistema y de cada módulo
---------------------------------------------------------------------------------*/
export const hora_fecha_version = "V5.0 04122023 18:20 - Prod";
export var version_sistema_footer = "5.0";
export var anio_copyright_footer = "2023";
export const idSistema = "652";

/*------------- ETIQUETAS GENERALES -------------*/
export const general_btn_aceptar     = "Aceptar";
export const general_btn_cancelar    = "Cancelar";
export const general_btn_modificar   = "Modificar";
export const general_btn_agregar    = "Agregar";
export const general_btn_guardar     = "Guardar";
export const general_btn_eliminar = "Eliminar";
export const general_btn_descargar = "Descargar";
export const general_btn_crear      = "Crear carpeta";
export const general_dato_requerido  = "Dato requerido";
export const general_formato_invalido = "Formato inválido";
export const general_formato_invalido_ine_mx = "El correo electrónico registrado de cada aspirante debe ser único y no debe contener el dominio @ine.mx";
export const general_telefono_requerido = "Ingrese al menos un número telefónico";
export const general_experiencia_laboral = "* Tu experiencia profesional nos ayuda a conocer tu perfil, captura lo que consideres necesario.";
export const general_telefono_requerido_leyenda = "*Al menos uno de los dos teléfonos es requerido";
export const general_lbl_si             = "Sí";
export const general_lbl_no             = "No";
export const general_lbl_regresar          = "Regresar";
export const general_lbl_footer_unidad_tecnica = "Unidad Técnica de Servicios de Informática";

export const gral_correo_duplicado = "El correo ya se encuentra registrado"
export const gral_no_selecciono_estado = "Por favor, seleccione un estado";
export const gral_modulo_cerrado = "El registro de aspirantes se encuentra cerrado";
export const gral_no_convo_activa_seccion = "No existe convocatoria activa en la sección.";
export const gral_clave_en_convocatoria = "La clave de elector ingresada se encuentra registrada en la convocatoria vigente.";
export const gral_clave_en_convocatoria_seleccionada = "El dato de clave de elector, OCR o SIAP ingresado se encuentra registrada en la convocatoria seleccionada.";
export const gral_descarga_compulsa_inter = "La descarga de compulsa fue interrumpida. Por favor inténtalo más tarde.";
export const gral_serivicio_no_disponible = "Servicio no disponible. Por favor inténtalo más tarde.";
export const gral_no_existe_clave_elector = "Los datos ingresados no se encuentran actualizados en lista nominal acude a JD.";
export const gral_correos_diferentes = "Los correos no son iguales.";
export const gral_sin_resultados = "Sin resultados para mostrar. Prueba con diferentes palabras."
export const gral_sin_registro_aspirantes  = "Aún no se cuenta con registro de aspirantes."
export const gral_no_participacion = "Sin participación geográfica."
export const gral_no_existe_convocatoria = "No existe convocatoria activa en la sección.";
export const gral_observacion_documentos="Encontramos observaciones en tus documentos, cárgalos de nuevo."
export const gral_archivos_permitidos = "Sólo se permiten los formatos PDF, JPG y  PNG.";
export const gral_peso_archivo = " debe ser menor a 1.5 MB";
export const gral_validando_documentos = "Validación de documentos en proceso.";
export const gral_documentos_validados = "Tus documentos fueron validados.";
export const gral_correo_confirmacion = "En breve recibirás un correo electrónico de confirmación.";
export const gral_solicitud_declinada = "Tu solicitud ha sido declinada, para mayor información comunícate a la Junta Distrital";

export const gral_error_cau = "El sistema no pudo realizar la acción solicitada, favor de comunicarse al CAU.";
export const gral_error_menor_edad = "El aspirante debe tener más de 18 años.";
export const gral_error_mayor_edad = "El aspirante debe tener menos de 60 años.";
export const gral_error_descargar_compulsa = "Ocurrió un error al descargar la compulsa.";
export const gral_error_nombre_archivo = "El nombre del documento no debe contener caracteres especiales.";
export const gral_error_descarga_acuse_capsula = "Ocurrió un error al descargar el acuse de la cápsula.";
export const gral_error_sede_examen = "Ocurrió un error al obtener la sede del examen.";
export const gral_error_guia_estudio = "Ocurrió un error al descargar la guia de estudio.";
export const gral_error_platicas = "Ocurrió un error al obtener la programación de cápsulas.";
export const gral_error_no_hay_platicas = "Aún no hay cápsulas programadas. Consulta el listado con la JDE.";
export const gral_error_reenvio = "Ocurrió un error al enviar las notificaciones.";
export const gral_error_no_hay_correo = "El aspirante no cuenta con correo electrónico registrado.";
export const gral_error_contacto = "Ocurrió un error al obtener los datos de contacto de la Junta Distrital.";
export const gral_error_fecha_fuera_rango = "Fecha fuera del periodo valido de la convocatoria.";
export const gral_error_administrador = "Ocurrio un error al actualizar el registro.";

/* ------------------ etiquetas menu ---------------- */
export const menu_element_uno = "Validar y dar seguimiento";
export const menu_element_dos = "Registrar un ciudadano";
export const menu_element_tres = "Reportes";
export const menu_element_junta_ejecutiva = "Juntas Ejecutivas"
export const menu_element_administrador = "Administrador";

/*------------- ETIQUETAS MODULO CONTACTO -------------*/
export const contacto_label_no_recibi_correo = "No recibí correo electrónico";
export const contacto_label_selecciona_una_opcion = "Selecciona una opción";
export const contacto_button_label_solicitar_correo = "Solicitar correo";
export const contacto_button_label_solicitar_correo_description = "Da clic aquí si deseas solicitar un reenvío de correo."
export const contacto_button_label_consultar_junta = "Consultar Junta Distrital";
export const contacto_button_label_consultar_junta_description = "Da clic aquí si requieres consultar los datos de la Junta Distrital que te corresponde."
export const contacto_label_datos_junta_distrital = "Datos de la Junta Distrital";
export const contacto_label_informativo_contacto = "Si requieres más información, ingresa los datos que se solicitan para consultar la Junta Distrital que te corresponde.";
export const contacto_label_informativo_modifica_correo = "Ingresa tus datos para solicitar un reenvío del correo";

/*------------- ETIQUETAS MODULO LOGIN -------------*/
export const login_btn_inicioSesion = "Inicia sesión"

export const login_lbl_usuario      = "Usuario"
export const login_lbl_constrasenia = "Contraseña"
export const login_lbl_registrate   = "Registrate ahora"

export const login_msg_constrasenia = "Utiliza tu Clave de Elector, OCR o tu SIAP. Si eres trabajador del INE, ingresa con tu usuario y contraseña institucional"
export const login_lbl_sesionActiva = "El usuario cuenta con una sesión activa, volverlo a intentar después de 30 minutos."
export const login_lbl_aviso_privacidad_integral = "Aviso de Privacidad Integral";
export const login_lbl_mensaje_inactividad = "La sesión ha finalizado por inactividad."

export const login_lbl_mensaje_codigo_201 = "Información incompleta para ejecutar la autenticación.";
export const login_lbl_mensaje_codigo_202 = "No se logró autenticar. Datos de ingreso incorrectos.";
export const login_lbl_mensaje_codigo_203 = "El usuario o aspirante no cuenta con la información completa.";
export const login_lbl_mensaje_codigo_204 = "El usuario no cuenta con un rol permitido en el sistema.";
export const login_lbl_mensaje_codigo_205 = "El usuario cuenta con una sesión activa. Intentar después de 30 minutos.";
export const login_lbl_mensaje_codigo_207 = "El periodo de reclutamiento concluyó.";
export const login_lbl_mensaje_codigo_500 = "Ocurrió un error en el servidor.";

/*------------- CONSTANTES MODULO LOGIN -------------*/
export const login_tiempo_inactividad = 12;

/*------------- ETIQUETAS REGISTRO ASPIRANTE -------------*/

export const datos_nombre_modulo_registro          = "Formulario de registro";

export const datos_credencial_lbl_titulo           = ""
export const datos_credencial_lbl_claveElectorFuar = "Clave de elector, OCR o SIAP"
export const datos_credencial_lbl_claveElectorFuarRepetir = "Confirma tu Clave de elector, OCR o SIAP"
export const datos_credencial_lbl_estado           = "Estado"
export const datos_credencial_lbl_seccion          = "Sección electoral"
export const datos_credencial_lbl_fechaRegistro    = "Fecha de registro"
export const datos_credencial_lbl_convocatoria     = "Convocatoria"
export const datos_credencial_lbl_sede_reclutamiento     = "Sede de reclutamiento"
export const datos_credencial_lbl_proceso          = "Proceso Electoral";

export const datos_personales_lbl_titulo           = "Datos personales"
export const datos_personales_lbl_rfc              = "RFC"
export const datos_personales_lbl_curp             = "CURP"
export const datos_personales_lbl_apellidoPaterno  = "Primer Apellido"
export const datos_personales_lbl_apellidoMaterno  = "Segundo Apellido"
export const datos_personales_lbl_nombre           = "Nombre (s)"
export const datos_personales_lbl_lugarNacimiento  = "Lugar de nacimiento"
export const datos_personales_lbl_fechaNacimiento  = "Fecha de nacimiento"
export const datos_personales_lbl_edad             = "Edad"
export const datos_personales_lbl_sexo             = "Género"
export const datos_personales_lbl_genero_femenino  = "Femenino"
export const datos_personales_lbl_genero_masculino = "Masculino"
export const datos_personales_lbl_genero_otro      = "Otro"
export const datos_personales_lbl_genero_sin_decir = "Prefiero no decir"
export const datos_personales_lbl_transgenero      = "¿Te identificas como persona LGBTTTIQ+?"
export const datos_personales_lbl_generoOtro       = "¿Con qué género te identificas?"
export const datos_personales_lbl_describe         = "Describe"
export const datos_personales_lbl_correoElectronico = "Correo electrónico"
export const datos_personales_lbl_confirmaCorreoElectronico = "Confirma tu correo electrónico"

export const datos_seleccion_proceso_cmbProceso_mensaje = "El Proceso Electoral seleccionado corresponde del (fecha del proceso)"
export const datos_seleccion_proceso_cmbProceso    = "Selecciona el Proceso a participar"
export const datos_seleccion_proceso_activo        = "Procesos Electorales Activos"
export const datos_direccion_lbl_titulo            = "Domicilio"
export const datos_direccion_lbl_calleNumero       = "Calle, número exterior, número interior"
export const datos_direccion_lbl_colonia           = "Colonia"
export const datos_direccion_lbl_cp                = "Código postal"
export const datos_direccion_lbl_municipio         = "Municipio o Alcaldía"
export const datos_direccion_lbl_localidad         = "Localidad"
export const datos_direccion_lbl_telefono          = "Teléfono fijo (10 digitos)"
export const datos_direccion_lbl_celular           = "Teléfono celular (10 digitos)"

export const datos_escolaridad_lbl_titulo            = "Escolaridad"
export const datos_escolaridad_lbl_escolaridad       = "Escolaridad (Último grado de estudios)"
export const datos_escolaridad_lbl_carrera           = "Carrera"
export const datos_escolaridad_lbl_estudioActual     = "Estudios que realiza actualmente"
export const datos_escolaridad_lbl_institucion       = "Institución"

export const datos_medio_difusion_lbl_titulo         = "Medio por el que te enteraste de la convocatoria"
export const datos_medio_difusion_lbl_mediosDifusion = "Seleccione según corresponda"
export const datos_medio_difusion_lbl_especifiqueMedio = "Especifique"
export const datos_medio_difusion_lbl_motivoParticipar = "¿Cuál es el motivo por el que quieres participar como SE o CAE?"

export const datos_experiencia_laboral_lbl_titulo             = "Experiencia laboral"
export const datos_experiencia_laboral_lbl_tituloEmpresa      = "Empleo anterior"
export const datos_experiencia_laboral_lbl_nombreEmpresa      = "Nombre de la empresa o Institución"
export const datos_experiencia_laboral_lbl_puestoEmpresa      = "Puesto"
export const datos_experiencia_laboral_lbl_fechaInicioEmpresa = "Fecha Inicio"
export const datos_experiencia_laboral_lbl_fechaFinEmpresa    = "Fecha Fin"
export const datos_experiencia_laboral_lbl_telefonoEmpresa    = "Teléfono"

export const datos_datos_otros_lbl_titulo                      = "Datos adicionales"
export const datos_datos_otros_lbl_participoProceso            = "¿Ha participado en algún proceso electoral?"
export const datos_datos_otros_lbl_cualProceso                 = "¿Cuál?"
export const datos_datos_otros_lbl_formasSeleccionadas         = "¿De qué forma has participado?"
export const datos_datos_otros_lbl_participoOtroEspecifique    = "Otro"
export const datos_datos_otros_lbl_diponibilidadTiempo         = "¿Tiene disponibilidad de tiempo para prestar sus servicios en horario fuera de lo habitual?"
export const datos_datos_otros_lbl_serviciosFinSemFestivos     = "¿Está dispuesta/o a prestar sus servicios en fines de semana y días festivos?"
export const datos_datos_otros_lbl_actividadesCampo            = "¿Está dispuesta/o a realizar actividades de campo? (visitar ciudadanos casa por casa, trasladarse grandes distancias, entre otros)"
export const datos_datos_otros_lbl_militantePartido            = "¿Milita en algún partido político u organización política o ha participado activamente en alguna campaña electoral en el último año?"
export const datos_datos_otros_lbl_representantePartido        = "¿Ha participado como representante de partido político con registro vigente, candidatura independiente registrada en el PE 2023-2024 o coalición en alguna elección realizada en los últimos tres años?"
export const datos_datos_otros_lbl_afinidadFamConsaguineo      = "¿Es familiar consanguíneo o por afinidad, hasta el 4° grado, de alguna persona que ostente el cargo de Vocal de la Junta Local o Distrital Ejecutiva o del Consejo Local o Distrital (Consejeras/os y representantes de partido político o, en su caso, candidatas/os independientes que ya estén registradas/os para el PE 2023-2024?"
export const datos_datos_otros_lbl_servidor_publico            = "Al momento de presentar esta solicitud, ¿participa como persona servidora pública de confianza con mando superior en cualquiera de los tres ámbitos de gobierno, persona operadora de programas sociales y actividades institucionales, servidor de la nación o haber ostentado alguno de estos cargos?"
export const datos_datos_otros_lbl_experienciaManejoGrupos     = "¿Cuenta con experiencia en manejo o trato con grupos?"
export const datos_datos_otros_lbl_impartirCapacitacion        = "¿Ha impartido capacitación presencial o virtual?"
export const datos_datos_otros_lbl_hablaLenguaIndigena         = "¿Habla alguna lengua indígena?"
export const datos_datos_otros_lbl_cualLenguaIndigena          = "¿Cuál?"
export const datos_datos_otros_lbl_sabeManejar                 = "¿Sabe conducir automóvil?"
export const datos_datos_otros_lbl_tieneLicenciaManejo         = "¿Cuenta con licencia de manejo?"
export const datos_datos_otros_lbl_vehiculoPropio              = "¿Cuenta con vehículo propio?"
export const datos_datos_otros_lbl_marcaModelo                 = "Anote marca y modelo"
export const datos_datos_otros_lbl_utilizarVehiculo            = "¿Está usted dispuesto(a) a utilizar su vehículo para sus actividades si el INE le brinda un apoyo económico para combustible?"
export const datos_datos_otros_lbl_tieneCelular                = "QUITAR... ¿Tiene teléfono celular?"
export const datos_datos_otros_lbl_companiaCelular             = "QUITAR... Anote el nombre de la compañía que le brinda el servicio"
export const datos_datos_otros_lbl_utilizarCelular             = "QUITAR... ¿Está usted dispuesto(a) a utilizar su teléfono celular para sus actividades si el INE le brinda los recursos económicos para la compra de tiempo aire?"
export const datos_datos_otros_lbl_tiempoTraslado              = "¿Cuánto tiempo le lleva trasladarse de su domicilio a la Junta Distrital Ejecutiva?"
export const datos_datos_otros_lbl_tieneInternet               = "¿Cuenta con acceso a Internet en su casa?"
export const datos_datos_otros_lbl_discapacidadesSeleccionadas = "¿Tiene alguna discapacidad?"
export const datos_datos_otros_lbl_especifiqueDiscapacidad     = "Especifique"
export const datos_experiencia_laboral_msj_fecha_anterior 	   = "La fecha debe ser anterior al empleo <num>.";
export const datos_experiencia_laboral_msj_fecha_posterior     = "La fecha debe ser posterior al empleo <num>.";
export const gral_orden_experiencia_laboral                    = "Registra los empleos que has tenido, del más reciente al más antiguo.";
export const sabe_utilizar_celular                             = "¿Sabe utilizar el teléfono celular?"

/*------------- ETIQUETAS BANDEJAS -------------*/
export const etiqueta_bandeja_registrados                      = "Registrados"
export const etiqueta_bandeja_por_validar                      = "Por validar"
export const etiqueta_bandeja_con_observaciones                = "Con observaciones"
export const etiqueta_bandeja_acuden_JDE                       = "Ciudadanos que acuden a la JDE"
export const etiqueta_bandeja_declinados                       = "Solicitud declinada"
export const etiqueta_bandeja_finalizados                      = "Finalizados"
export const etiqueta_resultado_registrados                    = "Resultados de ciudadanos registrados";
export const etiqueta_resultado_validar                        = "Resultados de ciudadanos por validar";
export const etiqueta_resultado_con_observaciones              = "Resultados de ciudadanos con observaciones";
export const etiqueta_resultado_acuden_JDE                     = "Resultados de ciudadanos que deben acudir a JDE";
export const etiqueta_resultado_declinados                     = "Resultados de ciudadanos con solicitud declinada";
export const etiqueta_resultado_finalizados                    = "Resultados de ciudadanos con solicitud finalizada";
export const etiqueta_mensaje_enviado                          = "El correo electrónico ha sido enviado con éxito";
export const etiqueta_mensaje_no_enviado                       = "El correo electrónico no pudo ser enviado";
export const etiqueta_mensaje_vacio_aspirante                  = "Escriba un mensaje al aspirante";
export const etiqueta_validar_correo                           = "Validar correo"
export const etiqueta_acudir_JDE                               = "Acudir a JDE"
export const etiqueta_quitar_sede_examen                       = "Quitar sede de examen"
export const etiqueta_registrado                               = "Registrado"
export const etiqueta_declinado                                = "Declinado"
export const etiqueta_finalizado                               = "Finalizado"
export const etiqueta_bandeja_titulo_modulo                    = "Búsqueda de ciudadanos";
export const etiqueta_bandeja_informacion_sin_documentos       = "El ciudadano no ha subido documentación, no es posible ejecutar la acción.";

/*------------- CONSTANTES BANDEJAS -------------*/
export const KEY_BANDEJA_REGISTRADOS                           = "0"
export const KEY_BANDEJA_POR_VALIDAR                           = "1"
export const KEY_BANDEJA_CON_OBSERVACIONES                     = "2"
export const KEY_BANDEJA_ACUDEN_JDE                            = "3"
export const KEY_BANDEJA_DECLINADOS                            = "4"
export const KEY_BANDEJA_FINALIZADOS                           = "5"
export const KEY_BANDEJA_SIN_DOCUS_ACUDE_JDE                   = "9"
export const KEY_BANDEJA_CON_DOCUS_ACUDE_JDE                   = "10"

export const ESTATUS_REGISTRADO                                = 1
export const ESTATUS_CON_DOCUMENTOS                            = 2
export const ESTATUS_APROBADO                                  = 3
export const ESTATUS_DECLINADO                                 = 4
export const ESTATUS_DECLINADO_ASPIRANTE                       = 5
export const ESTATUS_QUITAR_SEDE                               = 6
export const ESTATUS_VALIDAR_CORREO                            = 7
export const ESTATUS_COMPULSADO                                = 8

/*------------- CONSTANTES REGISTRO ASPIRANTE -------------*/

export const WIZARD_DATOS_CREDENCIAL               = 0
export const WIZARD_DATOS_PERSONALES               = 1
export const WIZARD_DATOS_DIRECCION                = 2
export const WIZARD_DATOS_ESCOLARIDAD              = 3
export const WIZARD_MEDIO_DIFUSION                 = 4
export const WIZARD_EXPERIENCIA_LABORAL            = 5
export const WIZARD_DATOS_OTROS                    = 6
export const REGEX_FORMATO_CLAVE_ELECTOR_FUAR_ANT       = /^([A-Z]{5,6}\d{8}[H|M|X]\d{3})$|^([0-9]{12,13})$/i;
export const REGEX_FORMATO_CLAVE_ELECTOR_FUAR       = /^([A-Z]{6}\d{8}[H|M|X]\d{3})$|^([0-9]{12,13})$/i;
export const REGEX_FORMATO_CLAVE_ELECTOR            = /^([A-Z]{6}\d{8}[H|M|X]\d{3})$/i;
export const REGEX_FORMATO_SIAP                     = /^([0-9]{12,13})$/i;
export const REGEX_FORMATO_NOMBRES                  = /^[A-ZÁÉÍÓÚÜÑ\'\°\.\-\/\s]*$/i;
export const REGEX_FORMATO_RFC                      = /^[A-Z]{3,4}[0-9]{6}([A-Z0-9]{3})*$/i;
export const REGEX_FORMATO_CURP                     = /^[A-Z]{4}[0-9]{6}[H|M|X][A-Z]{5}[A-Z0-9][0-9]$/i;
export const REGEX_FORMATO_CORREO                   = /^[_A-Z0-9-\+]+(\.[_A-Z0-9-]+)*@[A-Z0-9-]+(\.[A-Z0-9]+)*(\.[A-Z]{2,})$/i;
export const REGEX_FORMATO_TELEFONO                 = /^\d{8,10}$/i;
export const REGEX_FORMATO_TELEFONO_CEL                 = /^\d{10}$/i;
export const REGEX_FORMATO_NO_CARACTERES_ESPECIALES = /^[^\|\\\u00B4\"\<\>\@\&\=\(\)]*$/i;
export const REGEX_FORMATO_SOLO_DIGITOS             = /^\d*$/i;
export const FORMATO_FECHA_MOMENT                   = 'DD/MM/YYYY';
export const FORMATO_HORA_MOMENT                    = 'HH:mm:ss';

export const ID_PRIMERO_BACHILLERATO               = 10;
export const TITULO_AVISO                          = 0;
export const SUBTITULO_AVISO                       = 1;
export const TEXTO_AVISO                           = 2;
export const URL_AVISO                             = 3;
export const TITULO_DECLARO                        = 4;
export const INICIA_TEXTO_DECLARO                  = 5;
export const SEGUNDO_TEXTO_DECLARO                  = 6;
export const ID_ETIQUETA_NOMBRE_CORTO_PROCESO      = 68;
export const ID_ETIQUETA_NOMBRE_LARGO_PROCESO      = 69;

/*------------- ETIQUETAS MODIFICA CORREO ASPIRANTE -------------*/
export const modifica_correo_lbl_titulo           = "No recibí correo electrónico"
export const modifica_correo_lbl_claveElectorFuar = "Clave de elector, OCR o SIAP"
export const modifica_correo_lbl_estado           = "Estado"
export const modifica_correo_lbl_proceso          = "Proceso Electoral"
export const modifica_correo_lbl_seccion          = "Sección electoral"
export const modifica_correo_lbl_cp                = "Código postal"
export const modifica_correo_lbl_telefono          = "Teléfono fijo (10 digitos)"
export const modifica_correo_lbl_correoElectronico = "Nuevo correo electrónico"
export const modifica_correo_lbl_confirmaCorreoElectronico = "Confirma tu nuevo correo electrónico"

/*------------- ETIQUETAS COMBOS DE PROCESO, ENTIDAD, DISTRITO -------------*/
export const MENU_FILTROS_PROCESOS          = 'Proceso:';
export const MENU_FILTROS_PROCESOS_LABEL_0  = 'TODOS';
export const MENU_FILTROS_ESTADO            = 'Entidad:';
export const MENU_FILTROS_ESTADO_LABEL_0    = 'TODOS';
export const MENU_FILTROS_DISTRITO          = 'Distrito:';
export const MENU_FILTROS_DISTRITO_LABEL_0  = 'TODOS';
export const MENU_FILTROS_DISTRITO_NO_PARTICIPA = '-';

/*------------- ETIQUETAS GRÁFICA PARA NACIONAL Y ENTIDAD -------------*/
export const ETIQUETA_HOME_GRAFICA_TOTAL_ASPIRANTES_REGISTRADOS     =   'Aspirantes registrados en los procesos vigentes';
export const ETIQUETA_HOME_GRAFICA_ASPIRANTES_REGISTRADOS_EN_LINEA  =   'Aspirantes registrados en línea';
export const ETIQUETA_HOME_GRAFICA_ASPIRANTES_REGISTRADOS_EN_JDE  =   'Aspirantes registrados en JDE';
export const ETIQUETA_HOME_GRAFICA_NO_PARTICIPA_ENTIDAD             =   'No existen procesos vigentes en esta entidad';
export const ETIQUETA_HOME_GRAFICA_NO_PARTICIPA_DISTRITO            =   'No existen procesos vigentes en este distrito';

/*------------- ETIQUETAS MÓDULO JUNTA EJECUTIVA -------------*/
export const ETIQUETA_JUNTA_EJECUTIVA_TITULO_MODULO =  'Información de la Junta Distrital';
export const ETIQUETA_JUNTA_EJECUTIVA_NOMBRE_JUNTA = 'Nombre de la Junta Distrital';
export const ETIQUETA_JUNTA_EJECUTIVA_DOMICILIO = 'Domicilio';
export const ETIQUETA_JUNTA_EJECUTIVA_TELEFONO = '(LADA) Teléfono y extensión';
export const ETIQUETA_JUNTA_EJECUTIVA_TELEFONO_MODIFICA = 'Teléfono (con lada)';
export const ETIQUETA_JUNTA_EJECUTIVA_EXTENSION = 'Extensión';
export const ETIQUETA_JUNTA_EJECUTIVA_RESPONSABLE = 'Responsable';
export const ETIQUETA_JUNTA_EJECUTIVA_CORREO_ELECTRONICO = 'Correo electrónico';
export const ETIQUETA_JUNTA_EJECUTIVA_CALLE = 'Calle';
export const ETIQUETA_JUNTA_EJECUTIVA_NUMERO_EXTERIOR = 'No. Exterior';
export const ETIQUETA_JUNTA_EJECUTIVA_NUMERO_INTERIOR = 'No. Interior';
export const ETIQUETA_JUNTA_EJECUTIVA_COLONIA = 'Colonia';
export const ETIQUETA_JUNTA_EJECUTIVA_CODIGO_POSTAL = 'Código postal';
export const ETIQUETA_JUNTA_EJECUTIVA_MUNICIPIO = 'Municipio o alcaldía';
export const ETIQUETA_JUNTA_EJECUTIVA_REFERENCIAS = 'Referencias (entre calles)';
export const ETIQUETA_JUNTA_EJECUTIVA_TRATAMIENTO = 'Tratamiento';
export const ETIQUETA_JUNTA_EJECUTIVA_NOMBRES = 'Nombre(s)';
export const ETIQUETA_JUNTA_EJECUTIVA_PRIMER_APELLIDO = 'Primer apellido';
export const ETIQUETA_JUNTA_EJECUTIVA_SEGUNDO_APELLIDO = 'Segundo apellido';

/*------------- ETIQUETAS MÓDULO ACUSES ASPIRANTE EXTERNO -------------*/
export const ETIQUETA_ASPIRANTE_EXTERNO_TITULO_MODULO_ACUSES = 'Descarga de acuses'

/*------------- ETIQUETAS MÓDULO ADMINISTRADOR -------------*/
export const ETIQUETA_ADMINISTRADOR_TITULO_MODULO = 'Módulo de administración';
export const ETIQUETA_ADMINISTRADOR_LB_ASPIRANTES_SIN_COMPULSA = 'Aspirantes sin proceso de compulsa';
export const ETIQUETA_ADMINISTRADOR_LB_ASPIRANTES_SIN_ACUSE_COMPULSA = 'Aspirantes sin acuse de compulsa';
export const ETIQUETA_ADMINISTRADOR_LB_ASPIRANTES_SIN_ACUSE_PLATICA = 'Aspirantes sin acuse de cápsula de inducción';
export const ETIQUETA_ADMINISTRADOR_LB_ASPIRANTES_SIN_ACUSE_RECEPCION_DOCUMENTOS = 'Aspirantes sin acuse de recepción de documentos';
export const ETIQUETA_ADMINISTRADOR_LB_ASPIRANTES_SIN_ACUSE_VALIDACION_DOCUMENTOS = 'Aspirantes sin acuse de validación de documentos';
export const ETIQUETA_ADMINISTRADOR_BTN_EJECUTAR_COMPULSA = 'Ejecutar proceso de compulsa en faltantes';
export const ETIQUETA_ADMINISTRADOR_BTN_EJECUTAR_GENERAR_ACUSES_FALTANTES = 'Generar acuses faltantes';
export const ETIQUETA_ADMINISTRADOR_BTN_EJECUTAR_ACTUALIZAR_ACUSES = 'Actualizar todos los acuses';

export const ADMINISTRADOR_EJECUTAR_PROCESO_COMPULSA = 1;
export const ADMINISTRADOR_EJECUTAR_GENERAR_ACUSES_FALTANTES_COMPULSA = 2;
export const ADMINISTRADOR_EJECUTAR_GENERAR_ACUSES_TODOS_COMPULSA = 3;
export const ADMINISTRADOR_EJECUTAR_GENERAR_ACUSES_FALTANTES_PLATICA = 4;
export const ADMINISTRADOR_EJECUTAR_GENERAR_ACUSES_TODOS_PLATICA = 5;
export const ADMINISTRADOR_EJECUTAR_GENERAR_ACUSES_FALTANTES_RECEPCION = 6;
export const ADMINISTRADOR_EJECUTAR_GENERAR_ACUSES_TODOS_RECEPCION = 7;
export const ADMINISTRADOR_EJECUTAR_GENERAR_ACUSES_FALTANTES_VALIDACION = 8;
export const ADMINISTRADOR_EJECUTAR_GENERAR_ACUSES_TODOS_VALIDACION = 9;

/*------------- ETIQUETAS CÁPSULA -------------*/
export const etiqueta_ve_capsula_induccion  = "Ve la cápsula de inducción";

/*------------- CONSTANTES PARA EL COMPONENTE ModalMensajes.jsx -------------*/
export const CONSTANTE_MODAL_TIPO_MENSAJE_ERROR = 1;
export const CONSTANTE_MODAL_TIPO_MENSAJE_ADVERTENCIA = 2;
export const CONSTANTE_MODAL_TIPO_MENSAJE_NOTIFICACION = 3;
// Sirven para indicar los tipos de modales que se pueden presentar
export const CONSTANTE_MODAL_TIPO_MODAL_MENSAJE_SIMPLE = 1;
export const CONSTANTE_MODAL_TIPO_MODAL_CONFIRMACION = 2;
export const CONSTANTE_MODAL_TIPO_MODAL_INPUT_TEXT = 3;

/**
 * SUPYCAP.C_FECHAS
 */

/**
 * Identificador de la fecha de inicio de contratación del CAE
 */
export const ID_FECHA_INICIO_CONTRATACION_CAE = 20;

/**
 * SUPYCAP.C_PARAMETROS
 */

/**
 * Identificador del parámetro de apertura/cierre del módulo de registro de aspirantes
 */
export const ID_PARAMETRO_ESTATUS_MODULO_REGISTRO_ASPIRANTES    =   38;

/**
 * SUPYCAP.C_ETIQUETAS
 */

/**
 * Identificador de la etiqueta correspondiente a la ruta del publicador
 */
export const ID_ETIQUETA_RUTA_PUBLICADOR = 67;

/*------------- LINKS -------------*/

export const AVISO_PRIVACIDAD_INTEGRAL = "https://www.ine.mx/wp-content/uploads/2023/06/deceyec-aviso-privacidad-integral-SE-CAE.pdf";
export const CENTRO_DE_AYUDA = "https://intranetanterior.ine.mx/tutoriales/sistemas/Electorales/2024/federal/reclutaenlinea/";

/**
 * Roles de captura del sistema de reclutamiento en línea
 */
export const rolesCaptura = ['ANONYMOUS',
'SCE.ADMIN.OC', 'SCE.CAPTURA.OC',
'SCE.CAPTURA.JL', 'SCE.CAPTURA.JD',
'SCE.UNICOM.OC',
'SCE.CAPTURA_VCEYEC.JD',
'SCE.CAPTURA_VCEYEC.JL',
'SCE.CAPTURA_VE.JL','SCE.CAPTURA_VE.JD',
'SCE.CAPTURA_CONSEJERO.JL',
'SCE.CAPTURA_CONSEJERO.JD','SCE.CAPTURA_VS.JL',
'SCE.CAPTURA_VRFE.JL',
'SCE.CAPTURA_VOE.JL','SCE.CAPTURA_VS.JD',
'SCE.CAPTURA_VRFE.JD',
'SCE.CAPTURA_VOE.JD'];

export const rolesAdmin =  [ "SCE.ADMIN.OC", "SCE.UNICOM.OC", "SCE.CAPTURA.OC", "SCE.CAPTURA.JD", "SCE.CAPTURA_VCEYEC.JD" ];